<template>
  <div>
    <div class="modal fade" id="modal-actualizar-clave">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-support pt-2 pb-2">
            <h4 class="modal-title text-white">
              <i class="fas fa-key mr-2"></i>Actualizar Contraseña
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label for="password_current">Contraseña Actual</label>
              <div class="input-group">
                <input
                  ref="inputPasswordCurrent"
                  :type="mostrarPasswordCurrent ? 'text' : 'password'"
                  class="form-control form-control-sm"
                  v-model="form.password_current"
                  :class="
                    $v.form.password_current.$invalid ? 'is-invalid' : 'is-valid'
                  "
                  autocomplete="current-password"
                  @input="onPasswordCurrentInput"
                  @change="onPasswordCurrentInput"
                  @animationstart="onAutofillAnimationStart"
                />
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm btn-toggle-password"
                    :title="mostrarPasswordCurrent ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                    :aria-label="mostrarPasswordCurrent ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                    @click.prevent="mostrarPasswordCurrent = !mostrarPasswordCurrent"
                  >
                    <i
                      class="fas"
                      :class="mostrarPasswordCurrent ? 'fa-eye-slash' : 'fa-eye'"
                    ></i>
                  </button>
                </div>
              </div>
              <p class="text-danger small mb-0" v-if="!$v.form.password_current.required">
                Contraseña actual es requerida.
              </p>
            </div>

            <div class="form-group">
              <label for="password">Contraseña Nueva</label>
              <div class="input-group">
                <input
                  :type="mostrarPasswordNueva ? 'text' : 'password'"
                  class="form-control form-control-sm"
                  v-model="form.password"
                  :class="$v.form.password.$invalid ? 'is-invalid' : 'is-valid'"
                  autocomplete="new-password"
                />
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm btn-toggle-password"
                    :title="mostrarPasswordNueva ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                    :aria-label="mostrarPasswordNueva ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                    @click.prevent="mostrarPasswordNueva = !mostrarPasswordNueva"
                  >
                    <i
                      class="fas"
                      :class="mostrarPasswordNueva ? 'fa-eye-slash' : 'fa-eye'"
                    ></i>
                  </button>
                </div>
              </div>
              <p class="text-danger small mb-0" v-if="!$v.form.password.required">
                Contraseña es requerida.
              </p>
              <div
                class="alert alert-warning py-2 px-3 mt-2 mb-0 small"
                v-if="form.password && !$v.form.password.strongPassword"
              >
                La contraseña no cumple con los parámetros de seguridad:
                <ul class="mb-0 pl-3">
                  <li>Debe tener al menos una letra en mayúscula</li>
                  <li>Debe tener al menos una letra en minúscula</li>
                  <li>Debe tener al menos un número</li>
                  <li>Debe tener al menos un caracter especial</li>
                  <li>Debe tener al menos 12 caracteres</li>
                </ul>
              </div>
            </div>

            <div class="form-group">
              <label for="password_confirmation">Confirme Contraseña</label>
              <div class="input-group">
                <input
                  :type="mostrarPasswordConfirm ? 'text' : 'password'"
                  class="form-control form-control-sm"
                  v-model="form.password_confirmation"
                  :class="
                    $v.form.password_confirmation.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                  autocomplete="new-password"
                />
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm btn-toggle-password"
                    :title="mostrarPasswordConfirm ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                    :aria-label="mostrarPasswordConfirm ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                    @click.prevent="mostrarPasswordConfirm = !mostrarPasswordConfirm"
                  >
                    <i
                      class="fas"
                      :class="mostrarPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'"
                    ></i>
                  </button>
                </div>
              </div>
              <p
                class="text-danger small mb-0"
                v-if="!$v.form.password_confirmation.sameAsPassword"
              >
                Las contraseñas deben ser iguales.
              </p>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="cargando"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-update-password"
              :disabled="!puedeEnviar || cargando"
              @click="savePassword()"
            >
              <span
                v-if="cargando"
                class="spinner-border spinner-border-sm mr-2"
                role="status"
              ></span>
              <i v-else class="fas fa-save mr-1"></i>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";

export default {
  name: "UpdatePassword",
  data: () => ({
    form: {
      email: "",
      password: "",
      password_confirmation: "",
      password_current: "",
    },
    cargando: false,
    mostrarPasswordCurrent: false,
    mostrarPasswordNueva: false,
    mostrarPasswordConfirm: false,
    /** Delays para capturar autofill del navegador (no dispara v-model). */
    autofillSyncTimers: [],
  }),
  validations: {
    form: {
      email: { required, email },
      password: {
        required,
        minLength: minLength(12),
        strongPassword(password) {
          if (!password) return false;
          return (
            /[a-z]/.test(password) &&
            /[A-Z]/.test(password) &&
            /[0-9]/.test(password) &&
            /\W|_/.test(password) &&
            password.length >= 12
          );
        },
      },
      password_confirmation: {
        required,
        sameAsPassword: sameAs("password"),
      },
      password_current: { required },
    },
  },
  computed: {
    /** Evita depender solo de $invalid cuando el autofill no actualizó v-model aún. */
    puedeEnviar() {
      const f = this.form;
      const pwdOk =
        f.password &&
        f.password.length >= 12 &&
        /[a-z]/.test(f.password) &&
        /[A-Z]/.test(f.password) &&
        /[0-9]/.test(f.password) &&
        /\W|_/.test(f.password);
      const match = f.password === f.password_confirmation && !!f.password_confirmation;
      const currentOk = (f.password_current || "").length > 0;
      const emailOk = !!(f.email && String(f.email).includes("@"));
      return emailOk && currentOk && pwdOk && match;
    },
  },
  watch: {
    "$store.state.user": {
      handler(u) {
        if (u && u.email) {
          this.form.email = u.email;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onPasswordCurrentInput() {
      this.$v.form.password_current.$touch();
    },
    /** Chrome dispara animationstart al aplicar autofill en algunos casos. */
    onAutofillAnimationStart(e) {
      const name = e.animationName || "";
      if (name === "onAutoFillStart" || name.indexOf("onAutoFill") !== -1) {
        this.syncAutofillFromDom();
      }
    },
    syncAutofillFromDom() {
      const el = this.$refs.inputPasswordCurrent;
      if (!el || typeof el.value !== "string") return;
      if (el.value && el.value !== this.form.password_current) {
        this.form.password_current = el.value;
      }
      this.$v.form.password_current.$touch();
    },
    clearAutofillSyncTimers() {
      this.autofillSyncTimers.forEach((id) => clearTimeout(id));
      this.autofillSyncTimers = [];
    },
    scheduleAutofillSync() {
      this.clearAutofillSyncTimers();
      [0, 50, 150, 400, 800].forEach((ms) => {
        const id = setTimeout(() => {
          this.syncAutofillFromDom();
        }, ms);
        this.autofillSyncTimers.push(id);
      });
    },
    onModalShown() {
      this.mostrarPasswordCurrent = false;
      this.mostrarPasswordNueva = false;
      this.mostrarPasswordConfirm = false;
      const u = this.$store.getters.getUser;
      if (u && u.email) {
        this.form.email = u.email;
      }
      this.$nextTick(() => {
        this.scheduleAutofillSync();
      });
    },
    resetForm() {
      this.mostrarPasswordCurrent = false;
      this.mostrarPasswordNueva = false;
      this.mostrarPasswordConfirm = false;
      this.form = {
        email: this.$store.getters.getUser ? this.$store.getters.getUser.email : "",
        password: "",
        password_confirmation: "",
        password_current: "",
      };
    },
    savePassword() {
      this.syncAutofillFromDom();
      if (!this.puedeEnviar) {
        this.$v.form.$touch();
        return;
      }
      this.cargando = true;
      const data = this.form;
      axios
        .post("/api/password/update", data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          this.cargando = false;
          if (!response.data.user_error) {
            this.$refs.closeModal.click();
            this.resetForm();
            this.$swal({
              icon: "success",
              title: response.data.success || "Contraseña actualizada",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else {
            this.form.password_current = "";
            this.$swal({
              icon: "error",
              title: response.data.user_error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((e) => {
          this.cargando = false;
          const msg =
            (e.response && e.response.data && (e.response.data.message ||
              (e.response.data.errors &&
                Object.values(e.response.data.errors)[0][0]))) ||
            "Ocurrió un error, vuelva a intentarlo.";
          this.$swal({
            icon: "error",
            title: msg,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },
  },
  mounted() {
    const u = this.$store.getters.getUser;
    if (u && u.email) {
      this.form.email = u.email;
    }
    const modalEl = document.getElementById("modal-actualizar-clave");
    if (modalEl) {
      modalEl.addEventListener("shown.bs.modal", this.onModalShown);
    }
  },
  beforeDestroy() {
    this.clearAutofillSyncTimers();
    const modalEl = document.getElementById("modal-actualizar-clave");
    if (modalEl) {
      modalEl.removeEventListener("shown.bs.modal", this.onModalShown);
    }
  },
};
</script>

<style scoped>
.bg-support {
  background: #153f75 !important;
  color: #fff;
}
.btn-update-password {
  background: linear-gradient(135deg, #bad35c 0%, #9bc04a 100%);
  color: #1a2e0a;
  font-weight: 600;
  border: none;
}
.btn-update-password:hover:not(:disabled) {
  background: linear-gradient(135deg, #9bc04a 0%, #7fb83a 100%);
  color: #0f1d06;
}
.btn-update-password:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.modal-header.bg-support {
  border-bottom: 3px solid #bad35c;
}
.alert-warning ul {
  font-size: 0.85em;
}

.btn-toggle-password {
  border-color: #ced4da;
  color: #153f75;
  min-width: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-toggle-password:hover,
.btn-toggle-password:focus {
  color: #0d2850;
  background: rgba(21, 63, 117, 0.08);
  border-color: #153f75;
}
</style>

<!-- Sin scoped: Vue renombra @keyframes en scoped y rompe animationName en JS -->
<style>
@keyframes onAutoFillStart {
  from {
    opacity: 0.99;
  }
  to {
    opacity: 1;
  }
}
#modal-actualizar-clave input:-webkit-autofill {
  animation-name: onAutoFillStart;
  animation-duration: 0.001s;
}
</style>
